import clientSay1 from "images/client1.avif";
import clientSay4 from "images/client5.avif";
import clientSay5 from "images/client6.avif";

export const globalJson = {
  //
  prod_company_id: 595,
  dev_company_id: 595, //
  // apiUtil auth header key
  authToken: "Bearer 156|58t8SSr5MhZhuScrt9qczI7ywigBQQzfLGDO24SM",
  companyId: "a75b8a81-d900-402f-b0c3-5a362ff0f652",
  stripePublishableKey:
    "pk_live_51LdnoABqYa4ICTHoC6CjEgImHYOvUXXPs8psg8jZqXPxRwBt99nQEWtFFJj2n3ublkCJa0S8pYzDtvStF2JxUPzU00uWCskvlb",
  mapKey: "AIzaSyDKEntg7JydrxI7zr2tQL5OYcS5M-er-bc",
  residenceStateCode: "FL",

  //email confirmation admin token
  adminEmailToken:
    "vuRJfhz4wO5Odhxv682si70x95UA7zOxqz7sK2r7L8LJMXTsWiKM53edU24y4LYVgFqj4oI3OmaRFzDWoXA9GdCqNfyOciVYw9GO0kbDOepigLabYZDgnkw0ih6uLUgi",
  websiteLink: "https://mopacrental.com",
  sender: "mopac",
  ccEmail: "smartprentals@gmail.com",

  // apiUtil sendNewsLetterEmail
  util_serviceId: "service_0qh0217",
  util_templateId: "template_k4swowo",
  util_userId: "XU0TvMOEGy9VJQE5T",
  util_privateKey: "b3uzElNArs8Koz0Y9zWvo",

  // apiUtil getBonzahToken
  client_secret_dev:
    "SLxANOhVR/O9HK7QDelJBvbsz+i/XW5zVXYe49JeHyaHbf2RAvKunJyFWebq5ImbJpRDdUaEIp3Zu9fDL5Yt7VMX7lqe8iCMBzveJp1RfCM+Y+l5SW3iMMhO9h/8GDAwaCpZmg==",
  client_id_dev:
    "ab560362-ffc6-4dc7-a16a-fd43845deefc-20240522074089-vendor@bonzah.com",
  client_secret_prod:
    "SUnRy0BcS3KlKZFKcZljUTgxjm16B+lkDObgCvwe+Cyn4NIC1AqXwJgG4M4Z+6OyWphxUbNkrKr2F1WL9jxuhW3jLn9s0gBb8qF3ZxV4A18oWelsjDAg7CC1UHkPMQNH0A6+OA==",
  client_id_prod:
    "3646ae7f-dd0a-4aed-bd7e-f2d4bc9b3036-20240522501529-vendor@bonzah.com",

  about_us_para:
    "Whether you're looking for a high-end sports car, a sleek electric vehicle, or an affordable economy car, we provide top-notch customer service and a smooth rental process. Serving New York, our goal is to make your journey stylish, efficient, and hassle-free.From high-performance luxury cars to eco-friendly electric vehicles and affordable economy cars, we offer a wide selection of vehicles to suit every need. Whether you’re cruising through the streets of Manhattan or heading out for a weekend getaway, we’ve got the perfect ride for you. ",

  clientSays_arr: [
    {
      id: 1,
      clientName: "Aleesha M.",
      clientAddress: "February 23, 2025",
      content:
        "Great host. Rectified a small issue before it was ever a problem. Would rent from again.",
      img: clientSay1,
    },
    {
      id: 2,
      clientName: "Steven K.",
      clientAddress: "February 15, 2025",
      content: "Very comfortable car easy to work with host",
     
    },
    {
      id: 3,
      clientName: "Colton L.",
      clientAddress: "February 4, 2025",
      content:
        "Great to work with",
      
    },
    {
      id: 4,
      clientName: "Evan W.",
      clientAddress: "February 4, 2025",
      content:
        "Clean, great vehicle. Host was great with communication. Easy pick up and drop off.",
   
    },
    {
      id: 5,
      clientName: "Corey P.",
      clientAddress: "February 4, 2025",
      content:
        "Lightning fast communication when I had a question",
      img: clientSay4,
    },
    {
      id: 6,
      clientName: "Sheniya S.",
      clientAddress: "February 4, 2025",
      content:
        "Extremelyyyyyyy accommodating, quick responder, through directions and very clean rental ! I would give 10 stars if I could. Whenever o come back to Phoenix I’m definitely going with this host ! Thank youuuu Alex!!",
      img: clientSay5,
    },
  ],

  //social links
  facebook: "https://www.facebook.com/profile.php?id=61578937137761",
  instagram: "https://www.instagram.com/apex.luxe.rentals/",

  //contact
  address: "44 North 44th Street, Phoenix, AZ, USA",
  addressLink: "N/A",
  phone: "+16027485001",
  email: "pinhasovoperationsllc@gmail.com",
};

export const scriptHubSpot = document.createElement("script");
scriptHubSpot.src = "//js-na1.hs-scripts.com/46394417.js";
scriptHubSpot.async = true;
scriptHubSpot.defer = true;
scriptHubSpot.id = "hs-script-loader";
